// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span.file-title[data-v-226a866e]{overflow:hidden!important;text-overflow:ellipsis;white-space:nowrap}.delete-btn[data-v-226a866e]{bottom:5px;position:absolute;right:5px}.mdi-file-image[data-v-226a866e],.mdi-file-pdf[data-v-226a866e],.mdi-file-pdf-box[data-v-226a866e],.mdi-microsoft-excel[data-v-226a866e],.mdi-microsoft-word[data-v-226a866e]{color:#46649a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
